import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface IDeleteDatabasesParams {
  ids: string[];
}

export class DeleteDatabasesRequest extends Request<IDeleteDatabasesParams, IResult> {
  constructor(params: IDeleteDatabasesParams) {
    super('deleteDatabases', params);
  }
}
